import React, { useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { IconComponent } from '../../../sharedLegacy/components'
import {
  getTimeRemaining,
  getSeekBarPosition,
  getElapsedTime,
  getLoopingState,
  getCurrentPlaybackVideo,
} from '../../shared/selectors.playback'
import usePlaybackNewPosition from '../../hooks/usePlaybackNewPosition'
import usePlaybackIntent from '../../hooks/usePlaybackIntent'
import { setPlaybackSettings } from '../../../firebase/hooks/useVideoPlayback'

import './PlaybackVideoControlsBarComponent.scss'

const PlaybackVideoControlsBarComponent = (props) => {
  const {
    timeElapsed,
    timeRemaining,
    seekBarPosition,
    playingVideoIsPaused,
    playbackState,
    isVideoLooping,
    duration,
    selectedPlaybackVideo,
  } = props

  const elmBarWrapper = useRef(null)
  const { setNewPosition } = usePlaybackNewPosition()
  const { setPlaybackPlayIntent, togglePlayback } = usePlaybackIntent()

  const onSeekClick = (e) => {
    const clickOffsetX = e.nativeEvent.offsetX
    const positionClicked = clickOffsetX / elmBarWrapper.current.clientWidth

    setNewPosition(duration * positionClicked)
  }

  const onIconClick = () => {
    if (playbackState === 'ended') {
      setPlaybackPlayIntent(selectedPlaybackVideo)
    } else {
      togglePlayback()
    }
  }

  const playIcon =
    playingVideoIsPaused || playbackState === 'ended' ? 'play' : 'pause'

  return (
    <div className="playback-video-controls-bar-component">
      <div className="play-icon-wrapper">
        <IconComponent
          name={playIcon}
          className="play-icon"
          size={[12, 12]}
          color="AAA"
          onClick={onIconClick}
        />
      </div>
      <div className="time-elapsed">{timeElapsed}</div>
      <div className="seek-bar-clickarea" onClick={onSeekClick}>
        <div className="seek-bar-wrapper" ref={elmBarWrapper}>
          <div className="seek-bar" style={{ width: `${seekBarPosition}%` }} />
        </div>
      </div>
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      <div className="time-remaining">-{timeRemaining}</div>
      <IconComponent
        name="repeat"
        className="loop-icon"
        size={[16, 16]}
        color={isVideoLooping ? '1EC95B' : 'AAA'}
        onClick={() => setPlaybackSettings({ shouldLoop: !isVideoLooping })}
      />
    </div>
  )
}

PlaybackVideoControlsBarComponent.propTypes = {
  timeElapsed: PropTypes.string,
  timeRemaining: PropTypes.string,
  seekBarPosition: PropTypes.number,
  playingVideoIsPaused: PropTypes.bool,
  isVideoLooping: PropTypes.bool,
  duration: PropTypes.number,
  playbackState: PropTypes.string,
  selectedPlaybackVideo: PropTypes.object,
}

const mapStateToProps = (state) => ({
  timeElapsed: getElapsedTime(state),
  timeRemaining: getTimeRemaining(state),
  seekBarPosition: getSeekBarPosition(state),
  duration: state.webinarPlayback.videoDuration,
  playingVideoIsPaused: state.webinarPlayback.playingVideoIsPaused,
  playbackState: state.webinarPlayback.playbackState,
  selectedPlaybackVideo: getCurrentPlaybackVideo(state),
  isVideoLooping: getLoopingState(state),
})

export default connect(mapStateToProps)(PlaybackVideoControlsBarComponent)
